import "./navbar.scss";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import axios from "axios";
import Loader from "../../../hooks/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';
import { is_public_live, api_url, IS_DISTRIBUTING_POINT_OPEN, rain_twitter_url, IS_AQUA_SWAP_DEPOSIT_ACTIVE, USDT_SYMBOL, SHOW_GENERATE_MARKETS } from "../../../utils/Enviroment";
import { useTranslation } from "react-i18next";
import { DARK_THEME, DEFAULT_CHAIN, DEPOSIT, FOLLOW_TWITTER, getLanguageIcons, getNotificationEvent, INVITE, LIGHT_THEME, NOTIFICATION_STATUS_UNREAD, PERCENTAGE_OF_POINTS, PRED_ROUTE, QR_CODE_SIZE, REFERRAL_POINTS, TOKEN_ETH, TOKEN_RAIN, TOKEN_USDT, TOKEN_USDR, TWITTER_POINTS, TWITTER_VALUE, USDT_LOGO_SIZE } from "../../../utils/constants";
import { userSmartAccount, userTotalRewardPoints, userProfileData, userSmartAccountUsdtBalance, hasUnsavedCreateMarketChanges, pendingNavigationPath, rainPriceInUsdt, userSmartAccountRainBalance } from "../../RecoilAtom";
import { useRecoilState, useRecoilValue } from "recoil";
import { DepositViaWalletOrAddress, DepositViaAddress, DepositViaAccount, DepositSuccess } from "../../Deposit";
import { useTransfer } from "../../../hooks/dataSender/Transfer";
import { useConvertDeposit } from "../../../hooks/dataSender/ConvertDeposit";
import useBalance from "../../../hooks/dataFetcher/BalanceOf";
import { getDepositTokenConfig, handleDeposit, handleCopy, handleToastErrors, getFormatedWeb3Address, getTimeInAges, getDateInSlashes, formatNumbers } from "../../../utils/helpers";
import { useGetAllBalances } from "../../AllBalances";
import { ethToDollarConverter, getUsersNotification, postAllNotificationAsRead, postSantaRewardRecieved, postSingleNotificationAsRead, postUserReferralPoints, postUserRewardPoints, tokenToDollarConvertion } from "../../../utils/services";
import { getUsersProfile } from "../../../utils/services";
import { notificationToast } from "../../Toast";
import { useTheme } from "../../../contexts/ThemeProvider";
import { useSocketEvents } from "../../../hooks/dataFetcher/Socket";
import { useConnection } from "wagmi";
import WalletConnect from "../../WalletConnect/WalletConnect";
import GenerateMarkets from "../../GenerateMarkets";
import { ROUTES, detailPath, createPoolPath } from "../../../constants/Routes";


const Navbar = ({ show6, setShow6 }) => {
  const { theme, toggle } = useTheme();
  const connectRef = useRef(null);
  const disconnectRef = useRef(null);
  const [userTotalPoints, setUserTotalPoints] = useRecoilState(userTotalRewardPoints);
  const location = useLocation();
  const handleClose = () => { setShow(false) }
  const handleShow = () => setShow(true);
  const handleClose6 = () => setShow6(false);
  const [isCopied, setIsCopied] = useState(false);
  const [show, setShow] = useState(false);
  const [shownotification, setShowNotification] = useState(false);
  const handleCloseNotification = () => setShowNotification(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return localStorage.getItem("language") || "Eng";
  });
  const smartAccount = useRecoilValue(userSmartAccount)
  const languageIcon = getLanguageIcons[selectedLanguage];
  const [showmenu, setShowMenu] = useState(false);
  const handleCloseMenu = () => setShowMenu(false);
  const handleShowMenu = () => setShowMenu(true);
  const { t, i18n } = useTranslation();
  const { getTokenBalance } = useBalance();
  const transferFunds = useTransfer()
  const convertAndDeposit = useConvertDeposit()
  const [depositBalance, setDepositBalance] = useState();
  const [selectedToken, setSelectedToken] = useState(TOKEN_USDR);
  const [selectedChain, setSelectedChain] = useState(IS_AQUA_SWAP_DEPOSIT_ACTIVE ? DEFAULT_CHAIN : "Arbitrum");
  const [depositAmount, setDepositAmount] = useState("");
  const [selectedTokenConfig, setSelectedTokenConfig] = useState(null);
  const [showDepositAccOrAddr, setShowDepositAccOrAddr] = useState(false);
  const [showDepositViaAddress, setShowDepositViaAddress] = useState(false);
  const [showDepositViaAccount, setShowDepositViaAccount] = useState(false);
  const [showDepositSuccess, setShowDepositSuccess] = useState(false);
  const [isDepositing, setIsDepositing] = useState(false);
  const [rainPriceToUsdt, setRainPriceToUsdt] = useRecoilState(rainPriceInUsdt);
  const [showCreateSmart, setShowCreateSmart] = useState(false);
  const [showestablishconnection, setShowEstablishConnection] = useState(false);
  const [showsign, setShowSign] = useState(false);
  const [showImportSmart, setShowImportSmart] = useState(false);
  const [privateKey, setPrivateKey] = useState();
  const [copyKey, setCopyKey] = useState(false);
  const getAllBalances = useGetAllBalances();
  const [userProfile, setUserProfile] = useRecoilState(userProfileData);
  const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
  const smartAccountRainBalance = useRecoilValue(userSmartAccountRainBalance);
  const [showfollow, setShowFollow] = useState(false);
  const [notification, setNotification] = useState([]);
  const [notificationStatus, setNotificationStatus] = useState("all");
  const [unReadNotification, setUnReadNotification] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showsantamodal, setShowSantaModal] = useState(false);
  const [santaModalSpinner, setSantaModalSpinner] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showdrop, setShowDrop] = useState(false);
  const { address } = useConnection()
  const [hasUnsavedChanges, setHasUnsavedChanges] = useRecoilState(hasUnsavedCreateMarketChanges);
  const [pendingNavPath, setPendingNavPath] = useRecoilState(pendingNavigationPath);
  const SOCKET_EVENT_NOTIFICATION = `notifications/${userProfile?._id}`
  const handleCloseFollow = () => setShowFollow(false);
  const [showwalletbalance, setShowWalletBalance] = useState(false);

  const handleCloseSantaModal = async (navigateProfile) => {
    try {
      if (navigateProfile) {
        setSantaModalSpinner(true)
        await postSantaRewardRecieved();
        setShowSantaModal(false)
        setSantaModalSpinner(false)
        navigate(ROUTES.MYCREATEDPOLLS)
      } else {
        setShowSantaModal(false)
        await postSantaRewardRecieved()
      }
    } catch (error) {
      console?.log("error in santa reward api: ", error);
      setShowSantaModal(false)
      setSantaModalSpinner(false)
    }

  };


  const events = [
    {
      eventName: SOCKET_EVENT_NOTIFICATION,
      handler: (data) => {
        if (data) {
          setUnReadNotification(true)
          notificationToast(data?.job?.message)
          setNotification((prev) => {
            let updated = { ...prev };

            if (updated.notifications?.length > 0) {
              updated.notifications[0] = {
                ...updated.notifications[0],
                notifications: [data, ...(updated.notifications[0].notifications || [])]
              };
            } else {
              updated.notifications = [
                {
                  date: new Date().toISOString(),
                  notifications: [data],
                },
              ];
            }
            return updated;
          });
        }
      },
    }
  ];
  useSocketEvents(events);

  const FollowTwitter = async () => {
    window.open(rain_twitter_url, '_blank');
    const payload = {
      eventType: FOLLOW_TWITTER,
      value: TWITTER_VALUE,
      points: TWITTER_POINTS,
    };
    await postUserRewardPoints(payload);
    handleCloseFollow();
  };

  const handleNavigationRoute = (e, path) => {
    handleClose();
    if (hasUnsavedChanges) {
      e.preventDefault();
      setPendingNavPath(path);
    }
  };

  const confirmNavigation = () => {
    setHasUnsavedChanges(false);
    if (pendingNavPath) {
      navigate(pendingNavPath);
      setPendingNavPath(null);
    }
  };

  const cancelNavigation = () => {
    setPendingNavPath(null);
  };

  const copyPrivateKey = (text) => {
    handleCopy(text)
    setCopyKey(true)
    setTimeout(() => {
      setCopyKey(false);
    }, 1000);
  }

  const handleCloseImportSmart = () => {
    setShowImportSmart(false)
  }

  const handleCloseCreateSmart = () => {
    setShowCreateSmart(false)
  }

  const handleCloseEstablishConnection = () => {
    setShowEstablishConnection(false)
  }

  const handleCloseSign = () => {
    setShowSign(false)
  }


  useEffect(() => {
    if (smartAccount) {
      (async () => {
        await getAllBalances();
        if (accessToken) {
          const response = await getUsersProfile()
          setUserProfile(response?.data?.data)
          setShowSantaModal(response?.data?.data?.santaReward)
        }
      })();
    }
  }, [smartAccount, address, accessToken])

  const getBalance = async () => {
    try {
      const selectedCurrency = getDepositTokenConfig(selectedToken);
      setSelectedTokenConfig(selectedCurrency);
      const balanceRes = await getTokenBalance(
        selectedCurrency.tokenAddress,
        address,
        selectedCurrency.tokenDecimals
      );
      setDepositBalance(balanceRes);
    } catch (error) {
      console.error("Failed to fetch balance.");
    }
  };

  useEffect(() => {
    if (address) {
      getBalance();
    }
  }, [selectedToken, address]);

  const depositUsdtOrEth = async () => {
    const depositData = await handleDeposit({
      transferFunction: selectedToken === TOKEN_USDT ? convertAndDeposit : transferFunds,
      amount: depositAmount,
      tokenConfig: selectedTokenConfig,
      balance: depositBalance,
      toAddress: smartAccount,
      setIsLoading: setIsDepositing,
      onSuccess: () => {
        setShowDepositSuccess(true);
        setShowDepositViaAccount(false);
        setShowDepositAccOrAddr(false);
      },
      onError: (err) => console.log("Custom error handler:", err)
    });
    if (depositData && userProfile?.referredBy && !userProfile?.isSuccessfullyOnboarded && IS_DISTRIBUTING_POINT_OPEN) {
      const payload = {
        eventType: INVITE,
        value: "0",
        points: REFERRAL_POINTS
      }
      await postUserReferralPoints(payload)
      const addRewardToTotalPoints = +userTotalPoints + REFERRAL_POINTS;
      setUserTotalPoints(addRewardToTotalPoints);
    }
    if (depositData && IS_DISTRIBUTING_POINT_OPEN) {
      const ethPriceInUsdt = await ethToDollarConverter();
      const depositAmountInUsdt = selectedToken === TOKEN_ETH ? +depositAmount * ethPriceInUsdt : depositAmount;
      const depositPoints = selectedToken !== TOKEN_RAIN ? (+depositAmountInUsdt * PERCENTAGE_OF_POINTS) * 100 : ((+depositAmountInUsdt * +rainPriceToUsdt) * PERCENTAGE_OF_POINTS) * 100;;
      const payload = {
        eventType: DEPOSIT,
        value: depositAmountInUsdt,
        points: depositPoints,
        transactionHash: depositData?.transactionHash,
        token: {
          tokenSymbol: selectedToken === TOKEN_RAIN ? TOKEN_RAIN : USDT_SYMBOL,
        },
      }
      await postUserRewardPoints(payload)
      const addRewardToTotalPoints = +userTotalPoints + depositPoints;
      setUserTotalPoints(addRewardToTotalPoints);
    }

  };

  const getTokenToDollarPrice = async () => {
    try {
      const tokenPriceRes = await tokenToDollarConvertion(TOKEN_RAIN)
      setRainPriceToUsdt(tokenPriceRes)
    } catch (error) {
      console.log('error: ', error);

    }
  }

  const CheckTokenExpiration = async () => {
    const flag = localStorage.getItem("flag");
    const connectorId = localStorage.getItem("connectorId");
    if (!accessToken && connectorId) {
      setIsTokenExpired(true);
      return;
    }
    try {
      const response = await axios.get(
        `${api_url}/users/check-token-expiration?token=${accessToken}`
      );
      const tokenCheckData = response.data;
      if (tokenCheckData.isExpired && flag) {
        setIsTokenExpired(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        if (
          error.response.data &&
          error.response.data.message === "jwt malformed"
        ) {
          if (flag) {
            setIsTokenExpired(true);
          }
        } else {
          setIsTokenExpired(true);
          console.log("Unauthorized access.");
        }
      }
      console.error("Error checking token expiration:", error);
    }
  };

  useEffect(() => {
    CheckTokenExpiration();
  }, [location]);

  const getAllUserNotifications = async () => {
    try {
      const notificationsresponse = await getUsersNotification(notificationStatus)
      setNotification(notificationsresponse)
      setUnReadNotification(notificationsresponse?.unreadCount > 0 ? true : false)
    } catch (error) {
      console.log('error: ', error);
    }
  }

  useEffect(() => {
    if (address && notificationStatus) {
      (async () => {
        await getAllUserNotifications();
      })()
    }
  }, [address, notificationStatus]);


  const handleLanguageChange = (code, lang) => {
    localStorage?.setItem("language", lang);
    i18n.changeLanguage(code);
    setSelectedLanguage(lang);
  };

  const getCopiedStatus = (aquaSwapAddress) => {
    handleCopy(aquaSwapAddress ? aquaSwapAddress : smartAccount)
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  }

  const handleDepositClick = () => {
    if (address) {
      setShowDepositAccOrAddr(true);
    }
    else { handleToastErrors("Login to deposit!"); }
  };

  const scrollToHistory = async () => {
    navigate(ROUTES.MYCREATEDPOLLS, { state: { openHistoryTab: true } })
    setShowDepositSuccess(false)
    setDepositAmount("")
    await getAllBalances();
  };

  const handleMarkNotificationAsRead = async (id, poolId, status) => {
    try {
      if (id) {
        if (status === NOTIFICATION_STATUS_UNREAD && poolId === false) {
          await postSingleNotificationAsRead(id)
          await getAllUserNotifications()
        } else if (status === NOTIFICATION_STATUS_UNREAD && poolId) {
          window.open(detailPath(poolId), '_blank', 'noopener,noreferrer')
          await postSingleNotificationAsRead(id)
          await getAllUserNotifications()
          handleCloseNotification()
          setShowDrop(false)
        } else {
          window.open(detailPath(poolId), '_blank', 'noopener,noreferrer')
          handleCloseNotification()
          setShowDrop(false)
        }
      } else {
        await postAllNotificationAsRead()
        await getAllUserNotifications()
      }
    } catch (error) {
      console.log('error: ', error);
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getTokenToDollarPrice()
  }, [])

  const isAppRoute =
    location.pathname.startsWith(ROUTES.PRED) ||
    location.pathname.startsWith(ROUTES.PRIVATEMARKET) ||
    location.pathname.startsWith(ROUTES.USER_PROFILE);

  return (
    <>
      <DepositViaWalletOrAddress show={showDepositAccOrAddr} handleClose={() => setShowDepositAccOrAddr(false)} ShowDepositAddressModal={setShowDepositViaAddress} ShowDeposiAccountModal={setShowDepositViaAccount} smartAccount={address} />
      <DepositViaAddress
        show={showDepositViaAddress}
        setShow={setShowDepositViaAddress}
        handleClose={() => setShowDepositViaAddress(false)}
        QrCodeSize={QR_CODE_SIZE}
        QRCodeCanvas={QRCodeCanvas}
        smartAccount={smartAccount}
        UsdtLogoSize={USDT_LOGO_SIZE}
        isCopied={isCopied}
        handleCopy={getCopiedStatus}
        setSelectedToken={setSelectedToken}
        selectedToken={selectedToken}
        setSelectedChain={setSelectedChain}
        selectedChain={selectedChain}
      />
      <DepositViaAccount
        show={showDepositViaAccount}
        handleClose={() => setShowDepositViaAccount(false)}
        selectedBalance={depositBalance}
        setSelectedToken={setSelectedToken}
        selectedToken={selectedToken}
        DepositUsdtOrEth={depositUsdtOrEth}
        depositAmount={depositAmount}
        setDepositAmount={setDepositAmount}
        isDepositing={isDepositing}
      />
      <DepositSuccess
        show={showDepositSuccess}
        handleClose={() => { setShowDepositSuccess(false); setDepositAmount(""); getAllBalances() }}
        depositAmount={depositAmount}
        selectedToken={selectedToken}
        scrollToHistory={scrollToHistory}
      />

      {loader && <Loader />}
      <section className={`main-navbar${scrolled ? " navbarscroller" : ""}`}>
        <div className="custom-container">
          <nav class="navbar navbar-expand-xl p-0">
            <Link class="navbar-brand" to={isAppRoute ? "/pred" : "/"} onClick={(e) => handleNavigationRoute(e, isAppRoute ? "/pred" : "/")}>
              {
                theme === DARK_THEME ? <>
                  <img
                    src="\logo.svg"
                    alt="img"
                    className="img-fluid logohideinmobile"
                  />
                  <img
                    src="\logomobile.svg"
                    alt="img"
                    className="img-fluid d-none logoshowmobile"
                  />
                </> : <>
                  <img
                    src="\logolight.svg"
                    alt="img"
                    className="img-fluid logohideinmobile"
                  />
                  <img
                    src="\logomobilelight.svg"
                    alt="img"
                    className="img-fluid d-none logoshowmobile"
                  />
                </>
              }

            </Link>

            <div className="twice-items">
              {window.innerWidth < 991 && smartAccount && (
                <a onClick={handleDepositClick} id="btn-deposit" className="btn-depositmobile">
                  {t("Deposit")}
                </a>
              )}
              {window.innerWidth < 991 && (
                <WalletConnect onConnectClick={connectRef}
                  onDisconnectClick={disconnectRef} />
              )}
              {
                window.innerWidth < 991 && (
                  <button
                    class="navbar-toggler"
                    type="button"
                    onClick={handleShow}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M3 17H21M3 12H21M3 7H21"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                )
              }

            </div>

            <div
              class="collapse navbar-collapse justify-content-end"
              id="navbarSupportedContent"
            >
              <div className="inline-btns">
                {smartAccount ? <a onClick={handleDepositClick} id="btn-deposit" className="btn-deposit btn-depositnew">
                  {t("Deposit")}
                </a> : ""}
                {smartAccount && SHOW_GENERATE_MARKETS && (
                  <Link
                    to="/generatemarket"
                    className="generate-markets-btn"
                    onClick={(e) => handleNavigationRoute(e, '/generatemarket')}
                  >
                    Generate Markets
                  </Link>
                )}
                {smartAccount ? <Link id="button-create" to="createpool" className="btn-deposit">
                  {t("Create")}
                </Link> : ""}

                {address ? (
                  <>
                    <Dropdown show={dropdownOpen}
                      onToggle={(isOpen) => setDropdownOpen(isOpen)} className="dropdown connect-btn afterconnect" autoClose="outside">
                      <Dropdown.Toggle className="dropdown-toggle" id="dropdown-autoclose-outside">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <img
                            width={24}
                            height={24}
                            style={{ width: "24px", height: "24px" }}
                            src={
                              userProfile?.profilePic ||
                              "https://dh3bzuu7a45gi.cloudfront.net/gems/creator/81eacfe1d71041249a196234f5c5686e.jpeg"
                            }
                            alt="img"
                            className="img-fluid profile_pic"
                          />
                          ${formatNumbers(+smartAccountUsdtBalance + (+rainPriceToUsdt * +smartAccountRainBalance))}
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M6.69047 12.122L2.75297 8.18453C2.67088 8.10244 2.62476 7.9911 2.62476 7.875C2.62476 7.7589 2.67088 7.64756 2.75297 7.56547C2.83506 7.48337 2.9464 7.43726 3.0625 7.43726C3.1786 7.43726 3.28994 7.48337 3.37203 7.56547L6.5625 10.7565L6.5625 2.1875C6.5625 2.07147 6.60859 1.96019 6.69064 1.87814C6.77269 1.79609 6.88397 1.75 7 1.75C7.11603 1.75 7.22731 1.79609 7.30936 1.87814C7.39141 1.96019 7.4375 2.07147 7.4375 2.1875L7.4375 10.7565L10.628 7.56547C10.7101 7.48338 10.8214 7.43726 10.9375 7.43726C11.0536 7.43726 11.1649 7.48338 11.247 7.56547C11.3291 7.64756 11.3752 7.7589 11.3752 7.875C11.3752 7.9911 11.3291 8.10244 11.247 8.18453L7.30953 12.122C7.2689 12.1627 7.22065 12.195 7.16754 12.217C7.11443 12.239 7.05749 12.2503 7 12.2503C6.94251 12.2503 6.88558 12.239 6.83246 12.217C6.77935 12.195 6.7311 12.1627 6.69047 12.122Z" fill="black" />
                        </svg>


                      </Dropdown.Toggle>

                      <Dropdown.Menu className="when-connected">
                        <div className="wallet-balance">
                          <img
                            width={38}
                            height={38}
                            style={{ width: "38px", height: "38px" }}
                            src={
                              userProfile?.profilePic ||
                              "https://dh3bzuu7a45gi.cloudfront.net/gems/creator/81eacfe1d71041249a196234f5c5686e.jpeg"
                            }
                            alt="img"
                            className="img-fluid profile_pic"
                          />
                          <div className="text">
                            <p>{t("Balance")}</p>
                            <h6>${formatNumbers(+smartAccountUsdtBalance + (+rainPriceToUsdt * +smartAccountRainBalance))}</h6>
                          </div>
                        </div>
                        <li>
                          <Link to={ROUTES.MYCREATEDPOLLS} onClick={(e) => {
                            handleNavigationRoute(e, ROUTES.MYCREATEDPOLLS);
                            setDropdownOpen(false);
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("My Profile")}
                          </Link>
                        </li>
                        <li>
                          <a onClick={handleDepositClick} id="menu-deposit">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V13" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M16 19L19 22L22 19" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M18 12H18.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M19 16V22" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M6 12H6.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("Deposit")}
                          </a>
                        </li>
                        <li>
                          <Link to={ROUTES.MYPREDICTION} onClick={(e) => {
                            handleNavigationRoute(e, ROUTES.MYPREDICTION);
                            setDropdownOpen(false);
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M14.8281 14.828L21.0001 21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 16V21H16" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 3L12 12L8 8L2 14" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 8V3H16" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("My Predictions")}
                          </Link>
                        </li>
                        <li>
                          <Link to={ROUTES.POINTS_BREAKDOWN} onClick={(e) => {
                            handleNavigationRoute(e, ROUTES.POINTS_BREAKDOWN);
                            setDropdownOpen(false);
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M3 7.67135C3 5.99835 4.474 4.34435 5.51 3.39035C5.77923 3.14069 6.13284 3.00198 6.5 3.00198C6.86716 3.00198 7.22077 3.14069 7.49 3.39035C8.527 4.34435 10 5.99835 10 7.67035C10 9.31235 8.675 11.0003 6.5 11.0003C4.325 11.0003 3 9.31235 3 7.67135ZM8.5 17.6713C8.5 15.9983 9.974 14.3443 11.01 13.3893C11.2792 13.1397 11.6328 13.001 12 13.001C12.3672 13.001 12.7208 13.1397 12.99 13.3893C14.026 14.3443 15.5 15.9983 15.5 17.6713C15.5 19.3123 14.175 21.0003 12 21.0003C9.825 21.0003 8.5 19.3123 8.5 17.6713ZM14 7.67135C14 5.99835 15.474 4.34435 16.51 3.38935C16.7792 3.13969 17.1328 3.00098 17.5 3.00098C17.8672 3.00098 18.2208 3.13969 18.49 3.38935C19.527 4.34435 21 5.99835 21 7.67035C21 9.31235 19.675 11.0003 17.5 11.0003C15.325 11.0003 14 9.31235 14 7.67135Z" stroke="#E6FF00" stroke-width="1.5" />
                            </svg>
                            {t("Raindrops")}
                          </Link>
                        </li>
                        <li>
                          <Link onClick={() => {
                            handleClose();
                            setShowNotification(true);
                            setDropdownOpen(false);
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M10.268 21C10.4435 21.304 10.696 21.5565 11 21.732C11.3041 21.9075 11.6489 21.9999 12 21.9999C12.3511 21.9999 12.6959 21.9075 13 21.732C13.304 21.5565 13.5565 21.304 13.732 21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M3.262 15.326C3.13137 15.4692 3.04516 15.6472 3.01386 15.8385C2.98256 16.0298 3.00752 16.226 3.08571 16.4034C3.1639 16.5807 3.29194 16.7316 3.45426 16.8375C3.61658 16.9434 3.80618 16.9999 4 17H20C20.1938 17.0001 20.3834 16.9438 20.5459 16.8381C20.7083 16.7324 20.8365 16.5817 20.9149 16.4045C20.9933 16.2273 21.0185 16.0311 20.9874 15.8398C20.9564 15.6485 20.8704 15.4703 20.74 15.327C19.41 13.956 18 12.499 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 12.499 4.589 13.956 3.262 15.326Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("Notifications")}
                          </Link>
                        </li>
                        <li>
                          <div className="theme-toggle">
                            <div className="left-side">
                              {
                                theme != LIGHT_THEME ? <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                  <path d="M12.9901 7.32394C12.9276 8.48137 12.5312 9.59593 11.8488 10.5329C11.1664 11.4698 10.2272 12.1891 9.14474 12.6036C8.0623 13.0182 6.88294 13.1104 5.74924 12.869C4.61554 12.6276 3.57603 12.063 2.75636 11.2434C1.9367 10.4238 1.37198 9.38435 1.13047 8.25068C0.888954 7.117 0.980987 5.93764 1.39544 4.85515C1.8099 3.77266 2.52903 2.8334 3.46591 2.1509C4.40279 1.4684 5.5173 1.07188 6.67473 1.00927C6.94473 0.994607 7.08606 1.31594 6.94272 1.54461C6.46332 2.31164 6.25804 3.21852 6.36039 4.11724C6.46274 5.01596 6.86667 5.85346 7.50627 6.49306C8.14587 7.13266 8.98337 7.53659 9.88209 7.63894C10.7808 7.74129 11.6877 7.53601 12.4547 7.05661C12.6841 6.91327 13.0047 7.05394 12.9901 7.32394Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg> : <img src="\sun.svg" alt="img" />
                              }
                              <h6 style={{ fontWeight: "unset" }}>{theme === LIGHT_THEME ? t("Light Theme") : t("Dark Theme")}</h6>
                            </div>
                            <div className="custom-toggle-switch">
                              <div className="toggle-switch">
                                <input
                                  className="toggle-input"
                                  id="toggletheme"
                                  type="checkbox"
                                  checked={theme != LIGHT_THEME}
                                  onChange={toggle}
                                />
                                <label className="toggle-label" htmlFor="toggletheme"></label>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li >
                          <div class="dropdown lang-dropdown" style={{ margin: "0", width: "100%" }}>
                            <a
                              class="nav-link"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              style={{ justifyContent: "space-between" }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                                <img src={languageIcon} alt="img" className="img-fluid" />
                                {selectedLanguage}
                              </div>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.70999 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.40999C8.51999 10 8.07999 11.08 8.70999 11.71Z" fill="#DAD9D9" />
                              </svg>
                            </a>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              style={{ minWidth: "unset" }}
                            >
                              <li onClick={() => handleLanguageChange("en", "Eng")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\english.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  English
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("it", "Itl")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\italian.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Italian
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("jpn", "Jpn")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\jap.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Japanese
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("heb", "Heb")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\hebrew.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Hebrew
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("chi", "Chi")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\chinese.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Chinese
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("ger", "Ger")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\germany.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  German
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("arbc", "Arbc")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\arabic.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Arabic
                                </a>
                              </li>
                              <li onClick={() => handleLanguageChange("spn", "Spn")}>
                                <a class="dropdown-item" href="#">
                                  <img
                                    src="\assets\languagesicons\spanish.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />
                                  Spanish
                                </a>
                              </li>
                              <li></li>
                            </ul>
                          </div>
                        </li>
                        <li onClick={() => disconnectRef.current()}>
                          <a>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M11.25 20.25C11.25 20.4489 11.171 20.6397 11.0303 20.7803C10.8897 20.921 10.6989 21 10.5 21H4.5C4.30109 21 4.11032 20.921 3.96967 20.7803C3.82902 20.6397 3.75 20.4489 3.75 20.25V3.75C3.75 3.55109 3.82902 3.36032 3.96967 3.21967C4.11032 3.07902 4.30109 3 4.5 3H10.5C10.6989 3 10.8897 3.07902 11.0303 3.21967C11.171 3.36032 11.25 3.55109 11.25 3.75C11.25 3.94891 11.171 4.13968 11.0303 4.28033C10.8897 4.42098 10.6989 4.5 10.5 4.5H5.25V19.5H10.5C10.6989 19.5 10.8897 19.579 11.0303 19.7197C11.171 19.8603 11.25 20.0511 11.25 20.25ZM21.5306 11.4694L17.7806 7.71937C17.6399 7.57864 17.449 7.49958 17.25 7.49958C17.051 7.49958 16.8601 7.57864 16.7194 7.71937C16.5786 7.86011 16.4996 8.05098 16.4996 8.25C16.4996 8.44902 16.5786 8.63989 16.7194 8.78063L19.1897 11.25H10.5C10.3011 11.25 10.1103 11.329 9.96967 11.4697C9.82902 11.6103 9.75 11.8011 9.75 12C9.75 12.1989 9.82902 12.3897 9.96967 12.5303C10.1103 12.671 10.3011 12.75 10.5 12.75H19.1897L16.7194 15.2194C16.5786 15.3601 16.4996 15.551 16.4996 15.75C16.4996 15.949 16.5786 16.1399 16.7194 16.2806C16.8601 16.4214 17.051 16.5004 17.25 16.5004C17.449 16.5004 17.6399 16.4214 17.7806 16.2806L21.5306 12.5306C21.6004 12.461 21.6557 12.3783 21.6934 12.2872C21.7312 12.1962 21.7506 12.0986 21.7506 12C21.7506 11.9014 21.7312 11.8038 21.6934 11.7128C21.6557 11.6217 21.6004 11.539 21.5306 11.4694Z" fill="#FE3232" />
                            </svg>{" "}
                            {t("Log out")}
                          </a>
                        </li>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                ) : (
                  null
                )}
                {window.innerWidth > 991 && (
                  <WalletConnect onConnectClick={connectRef}
                    onDisconnectClick={disconnectRef} />
                )}
                {
                  !address && (
                    <div class="btn-group menu-btn-desktop">
                      <button class="dropdown-toggle" type="button" id="dropdownMenuClickableInside" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M3.3335 4.16675H16.6668" stroke="#DAD9D9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M3.3335 10H16.6668" stroke="#DAD9D9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M3.3335 15.8333H16.6668" stroke="#DAD9D9" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </button>
                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuClickableInside">
                        <div className="theme-toggle-desktop">
                          <h6>
                            {
                              theme != LIGHT_THEME ? <svg className="moon-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M20.985 12.4859C20.8913 14.2221 20.2967 15.8939 19.2731 17.2993C18.2495 18.7047 16.8407 19.7836 15.217 20.4054C13.5934 21.0273 11.8244 21.1655 10.1238 20.8034C8.42325 20.4414 6.86398 19.5944 5.63449 18.3651C4.40499 17.1357 3.55791 15.5765 3.19564 13.876C2.83337 12.1755 2.97142 10.4065 3.5931 8.78273C4.21478 7.159 5.29348 5.7501 6.6988 4.72635C8.10412 3.70259 9.77589 3.10782 11.512 3.01391C11.917 2.99191 12.129 3.47391 11.914 3.81691C11.1949 4.96746 10.887 6.32778 11.0405 7.67586C11.194 9.02394 11.7999 10.2802 12.7593 11.2396C13.7187 12.199 14.975 12.8049 16.3231 12.9584C17.6712 13.1119 19.0315 12.804 20.182 12.0849C20.526 11.8699 21.007 12.0809 20.985 12.4859Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg> : <img src="\sun.svg" alt="img" className="moon-icon" />
                            } {theme != LIGHT_THEME ? "Dark Theme" : "Light Theme"}
                          </h6>
                          <div className="custom-toggle-switch">
                            <div className="toggle-switch">
                              <input
                                className="toggle-input"
                                id="toggletheme"
                                type="checkbox"
                                checked={theme != LIGHT_THEME}
                                onChange={toggle}
                              />
                              <label className="toggle-label" htmlFor="toggletheme"></label>
                            </div>
                          </div>
                        </div>
                        <div class="dropdown lang-dropdown">
                          <button
                            class="dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className="inline-elem">
                              <img src={languageIcon} alt="img" className="img-fluid" />
                              {selectedLanguage}
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M8.70999 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.40999C8.51999 10 8.07999 11.08 8.70999 11.71Z" fill="#DAD9D9" />
                            </svg>
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li onClick={() => handleLanguageChange("en", "Eng")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\english.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                English
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("it", "Itl")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\italian.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Italian
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("jpn", "Jpn")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\jap.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Japanese
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("heb", "Heb")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\hebrew.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Hebrew
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("chi", "Chi")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\chinese.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Chinese
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("ger", "Ger")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\germany.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                German
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("arbc", "Arbc")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\arabic.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Arabic
                              </a>
                            </li>
                            <li onClick={() => handleLanguageChange("spn", "Spn")}>
                              <a class="dropdown-item" href="#">
                                <img
                                  src="\assets\languagesicons\spanish.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                Spanish
                              </a>
                            </li>
                            <li></li>
                          </ul>
                        </div>
                      </ul>
                    </div>
                  )
                }
              </div>
            </div>
          </nav>
        </div >
      </section >

      <Offcanvas className="mobile-offcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {" "}
            <a href="/">
              {
                theme === DARK_THEME ? <>
                  <img
                    src="\logo.svg"
                    alt="img"
                    className="img-fluid logohideinmobile"
                  />
                  <img
                    src="\logomobile.svg"
                    alt="img"
                    className="img-fluid d-none logoshowmobile"
                  />
                </> : <>
                  <img
                    src="\logolight.svg"
                    alt="img"
                    className="img-fluid logohideinmobile"
                  />
                  <img
                    src="\logomobilelight.svg"
                    alt="img"
                    className="img-fluid d-none logoshowmobile"
                  />
                </>
              }
            </a>{" "}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            {address && (
              <>
                <div className="different-background">
                  <div className="wallet-balance" onClick={() => setShowWalletBalance(!showwalletbalance)}>
                    <div className="left-balance">
                      <img
                        width={38}
                        height={38}
                        style={{ width: "38px", height: "38px" }}
                        src={
                          userProfile?.profilePic ||
                          "https://dh3bzuu7a45gi.cloudfront.net/gems/creator/81eacfe1d71041249a196234f5c5686e.jpeg"
                        }
                        alt="img"
                        className="img-fluid profile_pic"
                      />
                      <div className="text">
                        <p>{t("Balance")}</p>
                        <h6>${formatNumbers(+smartAccountUsdtBalance + (+rainPriceToUsdt * +smartAccountRainBalance))}</h6>
                      </div>
                    </div>
                    <svg className="arrow-icon" style={showwalletbalance ? { transform: "rotate(-90deg)" } : {}} xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
                      <path d="M4.95 6.363L0 1.413L1.414 0L7.778 6.363L1.414 12.727L0 11.312L4.95 6.363Z" fill="white" />
                    </svg>
                  </div>
                  {
                    showwalletbalance && (
                      <>
                        <li class="nav-item">
                          <Link to={ROUTES.MYCREATEDPOLLS} onClick={(e) => handleNavigationRoute(e, ROUTES.MYCREATEDPOLLS)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("My Profile")}
                          </Link>
                        </li>
                        <li class="nav-item">
                          <Link to={ROUTES.CREATEPOOL} onClick={(e) => handleNavigationRoute(e, ROUTES.CREATEPOOL)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M5 12H19" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12 5V19" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("Create Market")}
                          </Link>
                        </li>
                        {SHOW_GENERATE_MARKETS && (
                          <li class="nav-item">
                            <Link
                              to="/generatemarket"
                              onClick={(e) => handleNavigationRoute(e, '/generatemarket')}
                              class="nav-link"
                              aria-current="page"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 17L12 22L22 17" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 12L12 17L22 12" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              {t("Generate Markets")}
                            </Link>
                          </li>
                        )}
                        <li class="nav-item">
                          <a
                            onClick={() => {
                              handleDepositClick()
                              handleClose()
                            }}
                            id="menu-deposit"
                            class="nav-link"
                            aria-current="page"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V13" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M16 19L19 22L22 19" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M18 12H18.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M19 16V22" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M6 12H6.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("Deposit")}
                          </a>
                        </li>
                        <li class="nav-item">
                          <Link to={ROUTES.MYPREDICTION} onClick={(e) => handleNavigationRoute(e, ROUTES.MYPREDICTION)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M14.8281 14.828L21.0001 21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 16V21H16" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 3L12 12L8 8L2 14" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M21 8V3H16" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("My Predictions")}
                          </Link>
                        </li>
                        <li class="nav-item">
                          <Link to={ROUTES.POINTS_BREAKDOWN} onClick={(e) => handleNavigationRoute(e, ROUTES.POINTS_BREAKDOWN)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M3 7.67135C3 5.99835 4.474 4.34435 5.51 3.39035C5.77923 3.14069 6.13284 3.00198 6.5 3.00198C6.86716 3.00198 7.22077 3.14069 7.49 3.39035C8.527 4.34435 10 5.99835 10 7.67035C10 9.31235 8.675 11.0003 6.5 11.0003C4.325 11.0003 3 9.31235 3 7.67135ZM8.5 17.6713C8.5 15.9983 9.974 14.3443 11.01 13.3893C11.2792 13.1397 11.6328 13.001 12 13.001C12.3672 13.001 12.7208 13.1397 12.99 13.3893C14.026 14.3443 15.5 15.9983 15.5 17.6713C15.5 19.3123 14.175 21.0003 12 21.0003C9.825 21.0003 8.5 19.3123 8.5 17.6713ZM14 7.67135C14 5.99835 15.474 4.34435 16.51 3.38935C16.7792 3.13969 17.1328 3.00098 17.5 3.00098C17.8672 3.00098 18.2208 3.13969 18.49 3.38935C19.527 4.34435 21 5.99835 21 7.67035C21 9.31235 19.675 11.0003 17.5 11.0003C15.325 11.0003 14 9.31235 14 7.67135Z" stroke="#E6FF00" stroke-width="1.5" />
                            </svg>
                            {t("Raindrops")}
                          </Link>
                        </li>
                        <li class="nav-item">
                          <Link onClick={() => {
                            handleClose();
                            setShowNotification(true);
                          }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M10.268 21C10.4435 21.304 10.696 21.5565 11 21.732C11.3041 21.9075 11.6489 21.9999 12 21.9999C12.3511 21.9999 12.6959 21.9075 13 21.732C13.304 21.5565 13.5565 21.304 13.732 21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M3.262 15.326C3.13137 15.4692 3.04516 15.6472 3.01386 15.8385C2.98256 16.0298 3.00752 16.226 3.08571 16.4034C3.1639 16.5807 3.29194 16.7316 3.45426 16.8375C3.61658 16.9434 3.80618 16.9999 4 17H20C20.1938 17.0001 20.3834 16.9438 20.5459 16.8381C20.7083 16.7324 20.8365 16.5817 20.9149 16.4045C20.9933 16.2273 21.0185 16.0311 20.9874 15.8398C20.9564 15.6485 20.8704 15.4703 20.74 15.327C19.41 13.956 18 12.499 18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 12.499 4.589 13.956 3.262 15.326Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            {t("Notifications")}
                          </Link>
                        </li>
                      </>
                    )
                  }

                </div>


              </>
            )}
            <li class="nav-item">
              <Link to={PRED_ROUTE} onClick={(e) => handleNavigationRoute(e, PRED_ROUTE)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 5V9" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10 9H8C7.44772 9 7 9.44772 7 10V14C7 14.5523 7.44772 15 8 15H10C10.5523 15 11 14.5523 11 14V10C11 9.44772 10.5523 9 10 9Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 15V17" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17 3V5" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M18 5H16C15.4477 5 15 5.44772 15 6V12C15 12.5523 15.4477 13 16 13H18C18.5523 13 19 12.5523 19 12V6C19 5.44772 18.5523 5 18 5Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17 13V16" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {t("Explore Markets")}
              </Link>
            </li>
            <li class="nav-item">
              <Link to="/#faqs" onClick={(e) => {
                handleNavigationRoute(e, "/#faq")
                setTimeout(() => {
                  document.getElementById("faqs")?.scrollIntoView({ behavior: "smooth" });
                }, 300);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M16 5H3" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 12H3" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16 19H3" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21 5H21.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21 12H21.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21 19H21.01" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {t("FAQs")}
              </Link>
            </li>
            <li class="nav-item">
              <a href="https://whitepaper.rain.one/" target="_blank" onClick={() => {
                handleClose();
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H4" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V18C22 17.7348 21.8946 17.4804 21.7071 17.2929C21.5196 17.1054 21.2652 17 21 17H11C10.7348 17 10.4804 17.1054 10.2929 17.2929C10.1054 17.4804 10 17.7348 10 18V19C10 19.5304 9.78929 20.0391 9.41421 20.4142C9.03914 20.7893 8.53043 21 8 21ZM8 21C7.46957 21 6.96086 20.7893 6.58579 20.4142C6.21071 20.0391 6 19.5304 6 19V5C6 4.46957 5.78929 3.96086 5.41421 3.58579C5.03914 3.21071 4.53043 3 4 3C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5V7C2 7.26522 2.10536 7.51957 2.29289 7.70711C2.48043 7.89464 2.73478 8 3 8H6" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {t("Whitepaper")}
              </a>
            </li>
            <li className="nav-item">
              <div className="theme-toggle">
                <div className="left-side">
                  {
                    theme != LIGHT_THEME ? <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M12.9901 7.32394C12.9276 8.48137 12.5312 9.59593 11.8488 10.5329C11.1664 11.4698 10.2272 12.1891 9.14474 12.6036C8.0623 13.0182 6.88294 13.1104 5.74924 12.869C4.61554 12.6276 3.57603 12.063 2.75636 11.2434C1.9367 10.4238 1.37198 9.38435 1.13047 8.25068C0.888954 7.117 0.980987 5.93764 1.39544 4.85515C1.8099 3.77266 2.52903 2.8334 3.46591 2.1509C4.40279 1.4684 5.5173 1.07188 6.67473 1.00927C6.94473 0.994607 7.08606 1.31594 6.94272 1.54461C6.46332 2.31164 6.25804 3.21852 6.36039 4.11724C6.46274 5.01596 6.86667 5.85346 7.50627 6.49306C8.14587 7.13266 8.98337 7.53659 9.88209 7.63894C10.7808 7.74129 11.6877 7.53601 12.4547 7.05661C12.6841 6.91327 13.0047 7.05394 12.9901 7.32394Z" stroke="#DAD9D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> : <img src="\sun.svg" alt="img" />
                  }
                  <h6>{theme === LIGHT_THEME ? t("Light Theme") : t("Dark Theme")}</h6>
                </div>
                <div className="custom-toggle-switch">
                  <div className="toggle-switch">
                    <input
                      className="toggle-input"
                      id="toggletheme"
                      type="checkbox"
                      checked={theme != LIGHT_THEME}
                      onChange={toggle}
                    />
                    <label className="toggle-label" htmlFor="toggletheme"></label>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav-item">
              <div class="dropdown lang-dropdown" style={{ margin: "0", width: "100%" }}>
                <a
                  class="nav-link"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ justifyContent: "space-between" }}
                >
                  <div>
                    <img src={languageIcon} alt="img" className="img-fluid me-2" />
                    {selectedLanguage}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8.70999 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.40999C8.51999 10 8.07999 11.08 8.70999 11.71Z" fill="#DAD9D9" />
                  </svg>
                </a>
                <ul
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li onClick={() => handleLanguageChange("en", "Eng")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\english.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      English
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("it", "Itl")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\italian.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Italian
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("jpn", "Jpn")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\jap.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Japanese
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("heb", "Heb")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\hebrew.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Hebrew
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("chi", "Chi")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\chinese.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Chinese
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("ger", "Ger")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\germany.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      German
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("arbc", "Arbc")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\arabic.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Arabic
                    </a>
                  </li>
                  <li onClick={() => handleLanguageChange("spn", "Spn")}>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\languagesicons\spanish.svg"
                        alt="img"
                        className="img-fluid"
                      />
                      Spanish
                    </a>
                  </li>
                  <li></li>
                </ul>
              </div>
            </li>
          </ul>
          <div className="w-100">
            {!address ? (
              <a
                id="btn-login"
                className="btn-connect"
                onClick={() => {
                  handleClose();
                  connectRef.current();
                }}
              >
                {t("Login")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M15.5855 9.39792L10.523 14.4604C10.4174 14.566 10.2743 14.6253 10.125 14.6253C9.97573 14.6253 9.83258 14.566 9.72703 14.4604C9.62148 14.3549 9.56219 14.2117 9.56219 14.0624C9.56219 13.9132 9.62148 13.77 9.72703 13.6645L13.8298 9.56245H2.8125C2.66332 9.56245 2.52024 9.50318 2.41475 9.39769C2.30926 9.29221 2.25 9.14913 2.25 8.99995C2.25 8.85076 2.30926 8.70769 2.41475 8.6022C2.52024 8.49671 2.66332 8.43745 2.8125 8.43745H13.8298L9.72703 4.33542C9.62148 4.22987 9.56219 4.08671 9.56219 3.93745C9.56219 3.78818 9.62148 3.64503 9.72703 3.53948C9.83258 3.43393 9.97573 3.37463 10.125 3.37463C10.2743 3.37463 10.4174 3.43393 10.523 3.53948L15.5855 8.60198C15.6378 8.65422 15.6793 8.71626 15.7076 8.78454C15.7359 8.85283 15.7504 8.92603 15.7504 8.99995C15.7504 9.07387 15.7359 9.14706 15.7076 9.21535C15.6793 9.28364 15.6378 9.34567 15.5855 9.39792Z"
                    fill="black"
                  />
                </svg>
              </a>
            ) : (
              <a className="btn-disconnect" onClick={() => disconnectRef.current()}>
                {t("Log out")}
              </a>
            )}
          </div>


        </Offcanvas.Body>
      </Offcanvas>

      <Modal className="create" show={show6} onHide={handleClose6} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Create Market")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {is_public_live && (
            <Link to={createPoolPath("public")} onClick={handleClose6}>
              <div className="mainboxxx mb-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M15.5799 12.5C15.5799 14.48 13.9799 16.08 11.9999 16.08C10.0199 16.08 8.41992 14.48 8.41992 12.5C8.41992 10.52 10.0199 8.92004 11.9999 8.92004C13.9799 8.92004 15.5799 10.52 15.5799 12.5Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.9998 20.77C15.5298 20.77 18.8198 18.69 21.1098 15.09C22.0098 13.68 22.0098 11.31 21.1098 9.89997C18.8198 6.29997 15.5298 4.21997 11.9998 4.21997C8.46984 4.21997 5.17984 6.29997 2.88984 9.89997C1.98984 11.31 1.98984 13.68 2.88984 15.09C5.17984 18.69 8.46984 20.77 11.9998 20.77Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h6>{t("Public")}</h6>
                <p>
                  {t(
                    "Public Markets can be accessed by anyone. The resolver for this Market is the oracle"
                  )}
                </p>
              </div>
            </Link>
          )}
          <Link to={createPoolPath("private")}
            onClick={handleClose6}>
            <div className="mainboxxx">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M6 10.5V8.5C6 5.19 7 2.5 12 2.5C17 2.5 18 5.19 18 8.5V10.5"
                  stroke="#E6FF00"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 19C13.3807 19 14.5 17.8807 14.5 16.5C14.5 15.1193 13.3807 14 12 14C10.6193 14 9.5 15.1193 9.5 16.5C9.5 17.8807 10.6193 19 12 19Z"
                  stroke="#E6FF00"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 22.5H7C3 22.5 2 21.5 2 17.5V15.5C2 11.5 3 10.5 7 10.5H17C21 10.5 22 11.5 22 15.5V17.5C22 21.5 21 22.5 17 22.5Z"
                  stroke="#E6FF00"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h6>{t("Private")}</h6>
              <p>
                {t(
                  "Private Markets can only be accessed through a code and will be resolved by the creator of the Market"
                )}
              </p>
            </div>
          </Link>
        </Modal.Body>
      </Modal>
      <Offcanvas
        placement="bottom"
        className="mobile-offcanvas lang-menu"
        show={showmenu}
        onHide={handleCloseMenu}
      >
        <Offcanvas.Body>
          <div className="main-heading">
            <h6>{t("Select Language")}</h6>
          </div>
          <ul class="navbar-nav">
            <li
              onClick={() => {
                handleLanguageChange("en", "Eng");
                handleCloseMenu();
              }}
            >
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\english.svg"
                  alt="img"
                  className="img-fluid"
                />
                English
              </a>
            </li>
            <li
              onClick={() => {
                handleLanguageChange("it", "Itl");
                handleCloseMenu();
              }}
            >
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\italian.svg"
                  alt="img"
                  className="img-fluid"
                />
                Italian
              </a>
            </li>
            <li
              onClick={() => {
                handleLanguageChange("jpn", "Jpn");
                handleCloseMenu();
              }}
            >
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\jap.svg"
                  alt="img"
                  className="img-fluid"
                />
                Japanese
              </a>
            </li>
            <li
              onClick={() => {
                handleLanguageChange("heb", "Heb");
                handleCloseMenu();
              }}
            >
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\hebrew.svg"
                  alt="img"
                  className="img-fluid"
                />
                Hebrew
              </a>
            </li>
            <li onClick={() => handleLanguageChange("chi", "Chi")}>
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\chinese.svg"
                  alt="img"
                  className="img-fluid"
                />
                Chinese
              </a>
            </li>
            <li onClick={() => handleLanguageChange("ger", "Ger")}>
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\germany.svg"
                  alt="img"
                  className="img-fluid"
                />
                German
              </a>
            </li>
            <li onClick={() => handleLanguageChange("arbc", "Arbc")}>
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\arabic.svg"
                  alt="img"
                  className="img-fluid"
                />
                Arabic
              </a>
            </li>
            <li onClick={() => handleLanguageChange("spn", "Spn")}>
              <a class="dropdown-item" href="#">
                <img
                  src="\assets\languagesicons\spanish.svg"
                  alt="img"
                  className="img-fluid"
                />
                Spanish
              </a>
            </li>
            <li></li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal className="create importexisting-modal" show={showImportSmart} onHide={handleCloseImportSmart} centered>
        <Modal.Header closeButton>
          <Modal.Title>Import Existing Smart Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M28.3333 23.3333H28.3508" stroke="#DAD9D9" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.6667 11.6667H31.6667C32.5507 11.6667 33.3986 12.0179 34.0237 12.643C34.6488 13.2681 35 14.1159 35 15V31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H31.6667" stroke="#DAD9D9" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h5>Access Your Wallet</h5>
            <p>Import your private key to continue, or connect a different wallet to create a new one.</p>
            <textarea onChange={(e) => setPrivateKey(e.target.value)} type="text" placeholder="0x..."></textarea>
          </div>
          <div className="twice-btnss">
            <button onClick={handleCloseImportSmart} className="btn-cancel">Close</button>
            <button className="btn-common">{"Import"}</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="create importexisting-modal" show={showCreateSmart} onHide={handleCloseCreateSmart} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create Smart Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M28.3333 23.3333H28.3508" stroke="#DAD9D9" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.6667 11.6667H31.6667C32.5507 11.6667 33.3986 12.0179 34.0237 12.643C34.6488 13.2681 35 14.1159 35 15V31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H31.6667" stroke="#DAD9D9" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h5>Wallet Created</h5>
            <p>Save your private key securely — it's the only way to access your Rain wallet. <span className="textred">Losing it means losing your funds</span>.</p>
            <div className="wallet-parent">
              <div className="wallet-address">
                <p>Smart Account:</p>
                <div className="address-copy-text">
                  <h6>{getFormatedWeb3Address(smartAccount, true)}</h6>
                  {isCopied ? (
                    <p className="text-white">{t("copied")}</p>
                  ) : (
                    <a onClick={() => getCopiedStatus(smartAccount)} href="#"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                      <path d="M9.33333 8.02508V10.4751C9.33333 12.5167 8.51667 13.3334 6.475 13.3334H4.025C1.98333 13.3334 1.16667 12.5167 1.16667 10.4751V8.02508C1.16667 5.98341 1.98333 5.16675 4.025 5.16675H6.475C8.51667 5.16675 9.33333 5.98341 9.33333 8.02508Z" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M12.8333 4.52508V6.97508C12.8333 9.01675 12.0167 9.83341 9.975 9.83341H9.33333V8.02508C9.33333 5.98341 8.51667 5.16675 6.475 5.16675H4.66667V4.52508C4.66667 2.48341 5.48333 1.66675 7.525 1.66675H9.975C12.0167 1.66675 12.8333 2.48341 12.8333 4.52508Z" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    </a>
                  )}
                </div>
              </div>
              <div className="private-box">
                <p>Private Key</p>
                <h6>{privateKey}</h6>
              </div>
            </div>
          </div>
          <div className="twice-btnss">
            <button onClick={() => setShowCreateSmart(false)} className="btn-cancel">Close</button>
            <button onClick={() => copyPrivateKey(privateKey)} className="btn-common"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path d="M13.833 5.83325H7.16634C6.42996 5.83325 5.83301 6.43021 5.83301 7.16659V13.8333C5.83301 14.5696 6.42996 15.1666 7.16634 15.1666H13.833C14.5694 15.1666 15.1663 14.5696 15.1663 13.8333V7.16659C15.1663 6.43021 14.5694 5.83325 13.833 5.83325Z" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M3.16634 11.1666C2.43301 11.1666 1.83301 10.5666 1.83301 9.83325V3.16659C1.83301 2.43325 2.43301 1.83325 3.16634 1.83325H9.83301C10.5663 1.83325 11.1663 2.43325 11.1663 3.16659" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>{copyKey ? t("copied") : "COPY Private Key "}</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="create importexisting-modal" show={showestablishconnection} onHide={handleCloseEstablishConnection} centered>
        <Modal.Header style={{ border: "none", paddingBottom: "25px" }} closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                <path d="M24.1826 23.125C23.3253 27.1794 21.3579 30.9157 18.5001 33.9167C14.5414 29.7601 12.3334 24.2401 12.3334 18.5C12.3334 12.76 14.5414 7.23994 18.5001 3.08337C15.6509 3.08412 12.8576 3.87442 10.4303 5.36655C8.0031 6.85869 6.03684 8.99427 4.74984 11.5362C3.46283 14.0782 2.90544 16.9271 3.13953 19.7667C3.37362 22.6062 4.39004 25.3254 6.07595 27.6223C7.76186 29.9192 10.0513 31.7039 12.6901 32.7784C15.329 33.8529 18.214 34.1751 21.0248 33.7092C23.8357 33.2434 26.4624 32.0077 28.6135 30.1393C30.7646 28.2709 32.3559 25.843 33.2106 23.125" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.08325 18.5H16.1874" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M30.8334 9.25004V6.16671C30.8334 5.34896 30.5086 4.5647 29.9303 3.98646C29.3521 3.40822 28.5678 3.08337 27.7501 3.08337C26.9323 3.08337 26.1481 3.40822 25.5698 3.98646C24.9916 4.5647 24.6667 5.34896 24.6667 6.16671V9.25004" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M32.3749 9.25H23.1249C22.2735 9.25 21.5833 9.94023 21.5833 10.7917V15.4167C21.5833 16.2681 22.2735 16.9583 23.1249 16.9583H32.3749C33.2264 16.9583 33.9166 16.2681 33.9166 15.4167V10.7917C33.9166 9.94023 33.2264 9.25 32.3749 9.25Z" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h5>{t('Establish Connection')}</h5>
            <p style={{ color: "#737373" }}>{t('This signature is gas-free to send. It opens a decentralized channel for gas-free and instantenous trading')}</p>
            <div class="custom-checkbox">
              <input type="checkbox" id="html" />
              <label for="html">{t('Stay Connected')}</label>
            </div>
          </div>
          <div className="twice-btnss" style={{ gridTemplateColumns: "1fr" }}>
            <button className="btn-common">{t("Establish Connection")}</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="create importexisting-modal" show={showsign} onHide={handleCloseSign} centered>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                <path d="M26.2083 21.5833H26.2228" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10.7917 10.7917H29.2917C30.1094 10.7917 30.8937 11.1165 31.4719 11.6948C32.0501 12.273 32.375 13.0572 32.375 13.875V29.2917C32.375 30.1094 32.0501 30.8937 31.4719 31.4719C30.8937 32.0501 30.1094 32.375 29.2917 32.375H7.70833C6.89058 32.375 6.10632 32.0501 5.52809 31.4719C4.94985 30.8937 4.625 30.1094 4.625 29.2917V7.70833C4.625 6.89058 4.94985 6.10632 5.52809 5.52809C6.10632 4.94985 6.89058 4.625 7.70833 4.625H29.2917" stroke="#DAD9D9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h5>{t('Sign to Proceed')}</h5>
            <p style={{ color: "#737373" }}>{t('This signature confirms your identity and connects your wallet safely to the platform.')}</p>
          </div>
          <div className="twice-btnss" style={{ gridTemplateColumns: "1fr" }}>
            <button className="btn-common" id="btn-sign">{t("Sign")}</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="create importexisting-modal" show={showfollow} onHide={handleCloseFollow} centered>
        <Modal.Header style={{ border: "none", paddingBottom: "25px" }} closeButton>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="74" height="74" viewBox="0 0 74 74" fill="none">
                <rect width="74" height="74" rx="37" fill="#212121" fill-opacity="0.1" />
                <path d="M46.9894 21.5H52.0496L40.9946 34.2077L54 51.5H43.8169L35.8411 41.0123L26.7149 51.5H21.6516L33.4762 37.9077L21 21.5H31.4417L38.6511 31.0862L46.9894 21.5ZM45.2135 48.4538H48.0174L29.9181 24.3862H26.9092L45.2135 48.4538Z" fill="#212121" />
              </svg>
            </div>
            <h5>{t('Follow RAIN on X')}</h5>
            <p style={{ color: "#737373" }}>{t('Follow Rain on X to stay updated with news and announcements ')}</p>
          </div>
          <div className="twice-btnss" style={{ gridTemplateColumns: "1fr" }}>
            <button onClick={FollowTwitter} className="btn-common">{t("Follow RAIN on X")}</button>
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas placement="end" className="mobile-offcanvas" show={shownotification} onHide={handleCloseNotification}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Notifications
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="notification-parent">
            <div className="twice-items">
              <div className="filter-btns">
                <a onClick={() => setNotificationStatus("all")} className={notificationStatus === "all" ? "active" : ""}>{t("All")}</a>
                <a onClick={() => setNotificationStatus("unread")} className={notificationStatus === "unread" ? "active" : ""}>{t("Unread")}</a>
                <a onClick={() => setNotificationStatus("read")} className={notificationStatus === "read" ? "active" : ""}>{t("Read")}</a>
              </div>
              {unReadNotification ? <a onClick={() => handleMarkNotificationAsRead()} href="#" className="btn-mark">{t("Mark all as Read")}</a> : ""}
            </div>
            <div className="parent-list-notifiaction">
              {notification && notification?.notifications?.length > 0 ? (
                notification?.notifications?.map((item, index) => {
                  return (
                    <>
                      <p className="data-text">{getDateInSlashes(item?.date)}</p>
                      {item?.notifications?.map((innerItem, innerIndex) => {
                        return (
                          <div key={innerIndex} className={innerItem?.status === NOTIFICATION_STATUS_UNREAD ? "single-noti active" : "single-noti"}>
                            <div className="left-side">
                              <div className="noti-img">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                  <path d="M10.9999 20.1667C16.0625 20.1667 20.1666 16.0627 20.1666 11C20.1666 5.93743 16.0625 1.83337 10.9999 1.83337C5.93731 1.83337 1.83325 5.93743 1.83325 11C1.83325 16.0627 5.93731 20.1667 10.9999 20.1667Z" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M8.25 13.75L13.75 8.25" stroke="#E6FF00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </div>
                            </div>
                            <div className="right-side">
                              <div className="twice-elem">
                                <h6>
                                  {innerItem?.status === NOTIFICATION_STATUS_UNREAD ?
                                    <span className="activedot"></span> : ""}
                                  {t(getNotificationEvent[innerItem?.job?.type])}</h6>
                                {innerItem?.status === NOTIFICATION_STATUS_UNREAD ?
                                  <a onClick={() => handleMarkNotificationAsRead(innerItem?._id, false, innerItem?.status)} href="#">Mark as Read</a> : ""}
                              </div>
                              <p className="para">{innerItem?.job?.message} <a onClick={() => handleMarkNotificationAsRead(innerItem?._id, innerItem?.job?.poolId, innerItem?.status)} >Review results</a>.</p>
                              <p className="status">{getTimeInAges(innerItem?.createdAt)}</p>
                            </div>
                          </div>
                        )
                      })}
                    </>
                  )
                })
              ) : (
                <div className="whennopolls">
                  <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                    <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                    <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                    <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                    <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                    <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                    <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                    <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                  </svg>
                  <p>{t('No Notification Found')}</p>
                </div>
              )
              }
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Modal
        className="liquidity openadispute-modal"
        show={!!pendingNavPath}
        onHide={cancelNavigation}
        centered
      >
        <Modal.Body>
          <div className="innercontent p-0">
            <div className="upperimg">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="35" viewBox="0 0 32 35" fill="none">
                <g filter="url(#filter0_d_7262_10555)">
                  <path d="M18.5 25C18.5 25.4945 18.3534 25.9778 18.0787 26.3889C17.804 26.8001 17.4135 27.1205 16.9567 27.3097C16.4999 27.4989 15.9972 27.5484 15.5123 27.452C15.0273 27.3555 14.5819 27.1174 14.2322 26.7678C13.8826 26.4181 13.6445 25.9727 13.548 25.4877C13.4516 25.0028 13.5011 24.5001 13.6903 24.0433C13.8795 23.5865 14.2 23.196 14.6111 22.9213C15.0222 22.6466 15.5055 22.5 16 22.5C16.663 22.5 17.2989 22.7634 17.7678 23.2322C18.2366 23.7011 18.5 24.337 18.5 25ZM16 20C16.3978 20 16.7794 19.842 17.0607 19.5607C17.342 19.2794 17.5 18.8978 17.5 18.5V6C17.5 5.60218 17.342 5.22064 17.0607 4.93934C16.7794 4.65804 16.3978 4.5 16 4.5C15.6022 4.5 15.2206 4.65804 14.9393 4.93934C14.658 5.22064 14.5 5.60218 14.5 6V18.5C14.5 18.8978 14.658 19.2794 14.9393 19.5607C15.2206 19.842 15.6022 20 16 20Z" fill="#212121" />
                </g>
                <defs>
                  <filter id="filter0_d_7262_10555" x="-3.65714" y="0" width="39.3143" height="39.3143" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="3.65714" />
                    <feGaussianBlur stdDeviation="1.82857" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7262_10555" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7262_10555" result="shape" />
                  </filter>
                </defs>
              </svg>
            </div>
            <h2 className="upperheading">{t("Leaving This Page?")}</h2>
            <p className="para">
              {t("You will lose all progress and will need to start over from the beginning.")}
            </p>
          </div>
          <div className="twice-btns">
            <a onClick={confirmNavigation} className="btn-cancel">
              {t("Leave")}
            </a>
            <a onClick={cancelNavigation} className="btn-save">
              {t("Stay")}
            </a>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={showsantamodal}
        onHide={handleCloseSantaModal}
        centered
        className="pollmodal santareward-modal" backdrop="static">
        <Modal.Body>
          <div className="santaparent">
            <div className="upper-img">
              <img src="\assets\santa.gif" alt="img" className="img-fluid santagif" />
              {
                theme != LIGHT_THEME ? <img src="\assets\bottomsantashadow.png" alt="img" className="img-fluid bottom-shadow" /> :
                  <img src="\assets\bottomsantashadowlight.png" alt="img" className="img-fluid bottom-shadow" />
              }
            </div>
            <div className="parent-text">
              <h4>You've Received $RAIN</h4>
              <p className="para">Santa's gift has arrived. We’ve rewarded your trading activity with an airdrop of <span>RAIN tokens</span>. You can view your updated balance in your Profile right now.
              </p>
              <div className="incentiv-market">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <g clip-path="url(#clip0_10874_5236)">
                    <path d="M7.45258 11.6251C7.38562 11.3655 7.25034 11.1286 7.0608 10.9391C6.87125 10.7496 6.63439 10.6143 6.37483 10.5473L1.77358 9.36081C1.69508 9.33853 1.62599 9.29125 1.57679 9.22615C1.52759 9.16104 1.50098 9.08167 1.50098 9.00006C1.50098 8.91846 1.52759 8.83909 1.57679 8.77398C1.62599 8.70888 1.69508 8.6616 1.77358 8.63931L6.37483 7.45206C6.63429 7.38517 6.8711 7.24999 7.06063 7.06059C7.25017 6.87119 7.38551 6.63448 7.45258 6.37506L8.63908 1.77381C8.66114 1.695 8.70837 1.62557 8.77357 1.57611C8.83878 1.52665 8.91837 1.49988 9.00021 1.49988C9.08205 1.49988 9.16164 1.52665 9.22684 1.57611C9.29204 1.62557 9.33928 1.695 9.36133 1.77381L10.5471 6.37506C10.614 6.63462 10.7493 6.87149 10.9389 7.06103C11.1284 7.25057 11.3653 7.38586 11.6248 7.45282L16.2261 8.63856C16.3052 8.66039 16.375 8.70757 16.4247 8.77287C16.4744 8.83817 16.5014 8.91799 16.5014 9.00006C16.5014 9.08214 16.4744 9.16196 16.4247 9.22726C16.375 9.29256 16.3052 9.33974 16.2261 9.36156L11.6248 10.5473C11.3653 10.6143 11.1284 10.7496 10.9389 10.9391C10.7493 11.1286 10.614 11.3655 10.5471 11.6251L9.36058 16.2263C9.33853 16.3051 9.29129 16.3746 9.22609 16.424C9.16089 16.4735 9.0813 16.5003 8.99946 16.5003C8.91762 16.5003 8.83803 16.4735 8.77282 16.424C8.70762 16.3746 8.66039 16.3051 8.63833 16.2263L7.45258 11.6251Z" stroke="#F9AD51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15 2.25V5.25" stroke="#F9AD51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16.5 3.75H13.5" stroke="#F9AD51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3 12.75V14.25" stroke="#F9AD51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.75 13.5H2.25" stroke="#F9AD51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_10874_5236">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h6><span>Incentive Markets are live. </span> Start trading with RAIN and USD, more tokens to be added soon.</h6>
              </div>
              <div className="twice-btns-inline">
                <button onClick={() => handleCloseSantaModal(false)} className="btn-cancel">Dismiss</button>
                <button onClick={() => handleCloseSantaModal(true)} className="btn-wallet">{santaModalSpinner ? <span className="spinner" /> : "View Wallet"}</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;